import { useEffect } from 'react'
import { matchRoutes, useNavigate } from 'react-router-dom'
import routes from './index'
import { useSelector } from 'react-redux'
const acc_type = 'tea'

import { CommStateType } from '@/redux/reducer/commReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const AuthRoute = ({ children, auth }: { children: any; auth?: boolean }) => {
	const navigate = useNavigate()

	const token = useSelector<CommStateType, string>(state => state.comm.token)

	const mathchs = matchRoutes(routes, location)

	const isExist = mathchs?.some(item => item.pathname === location.pathname)

	useEffect(() => {
		if (!token && auth) {
			// navigate('/login')
			window.location.replace('/login')
		}
		// 这里判断条件是：token 存在并且是匹配到路由并且是已经登录的状态
		if (token && isExist) {
			const allowedPaths = ['/', '/tea', '/tea/', '/stu', '/stu/']
			const isAllowedPath = allowedPaths.includes(location.pathname)
			if (isAllowedPath) {
				navigate('/' + acc_type + '/home', { replace: true })
			} else if (location.pathname === '/login') {
				navigate('/home', { replace: true })
			}
		}
	}, [token, location.pathname])
	return children
}
export default AuthRoute
